import PropTypes from 'prop-types';
import { Component } from 'react';
import NotificationsDotButton from '../Dot/Button';
import { onCount } from './service';

export default class NotificationCount extends Component {
    static propTypes = {
        count: PropTypes.number.isRequired,
        actions: PropTypes.shape({
            doInitCount: PropTypes.func.isRequired,
        }).isRequired,
    };

    socket = null;

    componentWillUnmount() {
        if (this.socket) {
            this.socket();
            this.socket = null;
        }
    }

    componentDidMount() {
        this.checkCount();
    }

    checkCount() {
        onCount((countObj, firstCall) => {
            if (countObj) {
                const { count, lastChange, actions } = this.props;
                const newCount = countObj.count;
                const hasChanged = count !== newCount || lastChange !== countObj.lastChange;
                if (hasChanged || firstCall) {
                    actions.doInitCount(countObj);
                }
                if (hasChanged && newCount) {
                    const hasCountIncreased = count < newCount;
                    if (hasCountIncreased) {
                        actions.doGetNotifications({
                            limit: Math.min(newCount, 10),
                            offset: 0,
                            pushAlert: !firstCall,
                        });
                    }
                }
            }
        }).then(deregister => (this.socket = deregister));
    }

    render() {
        const { count } = this.props;
        const displayedCount = count > 99 ? '99+' : count;
        if (!count) {
            return null;
        }
        return <NotificationsDotButton>{displayedCount}</NotificationsDotButton>;
    }
}
